export const setPrepaidCard = async (context, prepaidCard) => {
  context.commit('SET_PREPAID_CARD', prepaidCard)
}
